import { Component, Input, OnInit, HostListener, ViewChild, ElementRef } from '@angular/core';
import { Router, Event, NavigationStart, NavigationEnd } from '@angular/router';

@Component({
  selector: 'mono-common-header',
  templateUrl: './header.component.html'
})
export class HeaderComponent implements OnInit {

  private readonly defaultLanguage = "en";
  private readonly defaultBurgerMenuText = "menu";

  @Input() signInLinkPath?: string;
  @Input() registrationLinkPath?: string;
  @Input() editMyDetailsLinkPath?: string;
  @Input() ariaLabelMainNav?: string;
  @Input() ariaLabelMobileNav?: string;
  @Input() ariaLabelBurgerButtonShow?: string;
  @Input() ariaLabelBurgerButtonHide?: string;
  @Input() hideUserLinks?: boolean = false;
  @Input() burgerMenuText?: string = this.defaultBurgerMenuText;
  @Input() language?: string = this.defaultLanguage;

  public showMobileMenu = false;
  public previousUrl: string;
  public isMobile = true;
  private nonMobileSize = 768;

  @ViewChild('burgerButton') burgerButton: ElementRef;

  @HostListener('window:resize', ['$event'])
  onResize(event) {
    if (event.target.innerWidth > this.nonMobileSize) {
      this.isMobile = false;
      this.showMobileMenu = false;
    } else {
      this.isMobile = true;
    }
  }

  constructor(private router: Router) {
    if (window.innerWidth > this.nonMobileSize) {
      this.isMobile = false;
    }
    this.router.events.subscribe((event: Event) => {
      if (event instanceof NavigationEnd) {
        this.previousUrl = event.url;
      }
      if (this.isMobile) {
        if (event instanceof NavigationStart) {
          this.showMobileMenu = false;
        }
      }
    });
  }

  ngOnInit(): void {
  }

  public toggleMenu() {
    this.showMobileMenu = !this.showMobileMenu;
    this.burgerButton.nativeElement.blur();
  }

}
